import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/auth'
import 'firebase/firestore'
import "firebase/performance";

// Initialize Firebase
var config = {
  apiKey: "AIzaSyBXrPDctifiX_pg3ElmuNfklbnPQv-ggK8",
  authDomain: "ashyaatcrm.firebaseapp.com",
  databaseURL: "https://ashyaatcrm.firebaseio.com",
  projectId: "ashyaatcrm",
  storageBucket: "ashyaatcrm.appspot.com",
  messagingSenderId: "697070147563",
  appId: "1:697070147563:web:55a5b1cd4ff0a849"
};
firebase.initializeApp(config);
var createFirebase = firebase.initializeApp(config, "Secondary");

const db = firebase.database();
const auth = firebase.auth();
const storageRef = firebase.storage().ref();
const perf = firebase.performance();
const store = firebase.firestore();

export {
  firebase,
  store,
  db,
  auth,
  perf,
  createFirebase,
  storageRef
};
